import React, { useCallback, useEffect, useMemo, useState } from 'react';
import SideBar from '../sidebar/SideBar';
import Header from '../header/Header';
import { Button, Steps } from 'antd';
import { toast } from 'react-toastify';
import { FaFileAlt } from 'react-icons/fa'
import { FaRegClock } from 'react-icons/fa6';
import { useLocation, useSearchParams } from 'react-router-dom';
// import { collection, getDocs, query, where } from 'firebase/firestore';
// import { db } from '../../config/firebase';
import AskForModel from '../shared/askForQuestion';
import { Modal } from "antd";
import DashboardLayout from '../layout';

import s1 from '../../assets/tracking-client/1.png'
import s2 from '../../assets/tracking-client/2.png'
import s3 from '../../assets/tracking-client/3.png'
import s4 from '../../assets/tracking-client/4.png'
import s5 from '../../assets/tracking-client/5.png'
import s6 from '../../assets/tracking-client/7.png'

import pdf from '../../assets/pdfIcon.svg'
import { calculateVolumeWeight } from '../../lib/helper/volumeWeight';
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getUserQuoteById } from "../../lib/quotes";
import { useMyContext } from "../../context/MyContext";
import dayjs from "dayjs";
import { BadgeCheck, CheckCircle, ClipboardCheck, Download, Expand, FileText, MapPin, Package, PackageCheck, PackageOpen, Plane, Truck } from 'lucide-react';
import axios from "axios"; 

const items = ['Collection', 'Compliance', 'In Transit', 'Custom Clearance', 'Final Delivery', "Delivered"]
const steps = [s1, s2, s3]

const DUMMY_DATA = {
    "unloadPostalCode": "411000",
    "sendStatus": true,
    "unloadAddress": "Test",
    "loadCountry": "India",
    "city": "Test",
    "services": [
        {
            "numberOfItem": 1,
            "description": "IOR",
            "exclVAT": "60"
        }
    ],
    "loadName": "Ashwin",
    "pkgType": "",
    "status": "Custom Clearance",
    "validityDate": "2025-11-15",
    "country": "",
    "eorGuarantee": "",
    "currency": "USD",
    "companyName": "",
    "pcsPackage": [
        {
            "weight": {
                "value": "10",
                "unit": "Kg"
            },
            "length": {
                "value": "100",
                "unit": "cm"
            },
            "width": {
                "unit": "cm",
                "value": "100"
            },
            "height": {
                "value": "100",
                "unit": "cm"
            },
            "quantity": "1"
        }
    ],
    "comments": [
        {
            "date": "25 Nov 2025 05:19 PM",
            "message": "hi",
            "user": "Ashwin Kumar"
        },
        {
            "message": "hi test",
            "date": "25 Nov 2025 05:19 PM",
            "user": "Ashwin Kumar"
        },
        {
            "message": "1",
            "date": "25 Nov 2025 05:20 PM",
            "user": "Ashwin Kumar"
        },
        {
            "date": "25 Nov 2025 05:20 PM",
            "message": "3",
            "user": "Ashwin Kumar"
        },
        {
            "user": "Ashwin Kumar",
            "message": "5",
            "date": "25 Nov 2025 05:20 PM"
        },
        {
            "date": "25 Nov 2025 05:20 PM",
            "message": "5",
            "user": "Ashwin Kumar"
        },
        {
            "message": "6",
            "date": "25 Nov 2025 05:20 PM",
            "user": "Ashwin Kumar"
        },
        {
            "message": "7",
            "user": "Ashwin Kumar",
            "date": "25 Nov 2025 05:20 PM"
        },
        {
            "message": "8",
            "user": "Ashwin Kumar",
            "date": "25 Nov 2025 05:20 PM"
        },
        {
            "date": "26 Nov 2025 12:06 PM",
            "message": "test question",
            "user": "Ashwin Kumar"
        },
        {
            "message": "test answer",
            "user": "Ashwin Kumar",
            "date": "26 Nov 2025 12:06 PM"
        },
        {
            "message": "test reply",
            "user": "admin",
            "date": "26 Nov 2025 12:07 PM"
        }
    ],
    "requestStatus": "unquoted",
    "address": "Test",
    "orderNumber": "AMS202512187",
    "userId": "7cGZiiilDRN7SkI7bjV3Q3ARsBo1",
    "creationDate": "2025-11-05T05:52:11.427Z",
    "subTotal": "60.00",
    "cargoValue": {
        "value": "10000.00",
        "currency": "USD"
    },
    "total": "60.60",
    "loadCity": "Pune",
    "serviceType": "IOR",
    "loadAddress_ReferenceCustomer": "Test",
    "description": "test desc",
    "inquireNumber": "IN2024-030",
    "shipmentCreatedDate": "2025-11-05T05:55:08.619Z",
    "selectedTemplate": "IOR",
    "userCountry": "Test",
    "cifValue": {
        "value": "11000.00",
        "currency": "USD"
    },
    "items": [
        {
            "itemName": "Test",
            "countryOrigin": "India",
            "itemValue": "10000",
            "quantity": "1",
            "hasHSCode": true,
            "itemHSCode": "851762"
        }
    ],
    "insurance": 0,
    "requestId": "AMfp1ivyij1dnrQpeA2l",
    "postalCode": "654321",
    "email": "ashwin.kumar.ndss@gmail.com",
    "loadAddress_PhoneNumber": "9876543210",
    "unloadCountry": "India",
    "loadPostalCode": "411000",
    "unloadAddress_PhoneNumber": "9876543210",
    "quoteCreatedDate": "2025-11-05T05:54:40.542Z",
    "quoteNumber": "Q20251840",
    "totalWeight": 10,
    "vatAmount": "0.60",
    "docFiles": [{
        "name": "invoice_123.pdf",
        "url": "https://firebasestorage.googleapis.com/v0/b/.../invoice_123.pdf"
    },
    {
        "name": "report_january.xlsx",
        "url": "https://firebasestorage.googleapis.com/v0/b/.../report_january.xlsx"
    },
    {
        "name": "shipment_list.csv",
        "url": "https://firebasestorage.googleapis.com/v0/b/.../shipment_list.csv"
    }],
    "loadAddress_CompanyName": "Test Company",
    "unloadAddress_CompanyName": "",
    "vatPercentage": "1",
    "unloadCity": "Pune",
    "trackingNumber": "75872516",
    "requiredDoc": "Required",
    "unloadName": "Ashwin",
    "insureShipment": "",
    "unloadAddress2": "",
    "modeOfTransfer": "By Road",
    "invoiceDetail": {
        "additionDetails": "",
        "invoiceFile": null
    },
    "name": "Ashwin Kumar",
    "agreeTerms": true,
    "loadAddress2": "",
    "loadAddress": "Test"
}


const Tracking = () => {
    const obj = {
        active: true,
        content: "Tracking Shipments",
    };

    const location = useLocation();
    const [searchParams] = useSearchParams();
    const prefetchedShipment = location.state?.prefetchedShipment || {};
    const prefetchedTrackingNumber = location.state?.trackingNumber || '';

    const [shipment, setShipment] = useState(prefetchedShipment);
    const [searchQuery, setSearchQuery] = useState(prefetchedTrackingNumber);
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [selectedId, setSelectedId] = useState(null);
    const [filteredData, setFilteredData] = useState("");
    const [animateNow, setAnimateNow] = useState(false)
    const [loading, setLoading] = useState(false);
    const { user, notifications } = useMyContext();
    const isAdmin = useMemo(() => {
        const role = (user?.role || '').toLowerCase();
        return [
            'super admin',
            'managing admin',
            'lead admin',
            'editor'
        ].includes(role);
    }, [user?.role]);
    const shipmentDocuments = useMemo(() => {
        const asArray = (value) => {
            if (!value) return [];
            return Array.isArray(value) ? value : [value];
        };

        // Merge both fields so legacy/new data combinations still show all files.
        const merged = [...asArray(shipment?.docFiles), ...asArray(shipment?.documents)];

        // De-duplicate by URL (fallback name) to avoid repeated cards.
        const seen = new Set();
        return merged.filter((doc) => {
            if (!doc) return false;
            const key = doc.url || doc.name;
            if (!key || seen.has(key)) return false;
            seen.add(key);
            return true;
        });
    }, [shipment]);

    const { data } = useQuery(
        ["userQuotes", user?.uid],
        async () => {
            const res = await getUserQuoteById(user?.uid);
            return res;
        },
        {
            refetchOnWindowFocus: false,
        }
    );

    useEffect(() => {
        if (data) {

            FilterData();
        }
    }, [data]);

    const FilterData = () => {
        // Check if data exists and is an array
        if (!data || !Array.isArray(data)) {
            setFilteredData([]);
            return;
        }

        // Initialize filtered data with all data
        let filtered = data.filter(
            (item) => item.status !== "pending" && item.status !== "decline"
        );

        if (searchQuery.trim() !== "") {
            // Filter data based on search query if it's not empty
            filtered = filtered.filter((directory) =>
                Object.values(directory).some(
                    (value) =>
                        typeof value === "string" &&
                        value.toLowerCase().includes(searchQuery.toLowerCase())
                )
            );
        }

        filtered.sort(
            (a, b) =>
                dayjs(b.creationDate).valueOf() - dayjs(a.creationDate).valueOf()
        );

        setFilteredData(filtered);

    };

    const showModal = async (id) => {
        setSelectedId(id);
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

/*     const handleSearch = async () => {
        if (!searchQuery.trim()) {
            toast.error('Please enter a tracking number');
            return;
        }
        const match = filteredData.find(
            (item) => item.trackingNumber === searchQuery
        );
        if (!match) {
            toast.error("Tracking ID not found");
            return;
        }

        setLoading(true);
        try {
            const q = query(collection(db, "quotes"), where("trackingNumber", "==", searchQuery));
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                const data = querySnapshot.docs[0].data();
                setAnimateNow(false)
                setShipment(data);
                setSelectedId(querySnapshot.docs[0].id);
            } else {
                setShipment({});
                toast.error('Quote data not found');
            }
        } catch (error) {
            console.error('Error fetching Quote data:', error);
            toast.error('Error fetching Quote data');
        } finally {
            setLoading(false);
        }
    }; */


const fetchShipmentByTrackingNumber = async (trackingNumber, showMissingNumberToast = false) => {
    if (!trackingNumber?.trim()) {
        if (showMissingNumberToast) {
            toast.error('Please enter a tracking number');
        }
        return;
    }

    setLoading(true);

    try {
        const res = await axios.get(`/api/tracking/trackshipment/${trackingNumber}`);

        if (res.data?.data) {
            // Enforce ownership for non-admin users
            if (!isAdmin && res.data.data?.userId && res.data.data.userId !== user?.uid) {
                setShipment({});
                toast.error('Tracking ID not found');
                return;
            }
            setShipment(res.data.data);
            setSelectedId(res.data.data.id || null);
        } else {
            setShipment({});
            toast.error("Shipment not found");
        }
    } catch (error) {
        console.error(error);
        toast.error("Tracking ID not found");
        setShipment({});
    } finally {
        setLoading(false);
    }
};

const handleSearch = async () => {
    // For non-admins, ensure the tracking number exists in user's own shipments
    if (!isAdmin) {
        const match = Array.isArray(filteredData)
            ? filteredData.find((item) => item.trackingNumber === searchQuery)
            : null;
        if (!match) {
            toast.error('Tracking ID not found');
            return;
        }
    }
    await fetchShipmentByTrackingNumber(searchQuery, true);
};

useEffect(() => {
    const trackingNumberFromUrl = searchParams.get("trackingNumber");
    if (!trackingNumberFromUrl) return;

    const normalizedTrackingNumber = trackingNumberFromUrl.replace(/\D/g, '');
    if (!normalizedTrackingNumber) return;

    setSearchQuery(normalizedTrackingNumber);
    if (shipment?.trackingNumber === normalizedTrackingNumber) return;
    fetchShipmentByTrackingNumber(normalizedTrackingNumber);
}, [searchParams, shipment?.trackingNumber]);


    const downloadDocument = async (item) => {
        if (!item?.url) {
            toast.error("Document URL is missing");
            return;
        }

        try {
            const response = await fetch(
                `/api/tracking/download-attachment?url=${encodeURIComponent(
                    item.url
                )}&filename=${encodeURIComponent(item?.name || "document")}`
            );
            if (!response.ok) throw new Error("Failed to fetch document");

            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = item?.name || "document";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            toast.error("Unable to download document. Please try again.");
        }
    };

    const renderDoc = (item) => {
        const extension = item?.name.split('.').pop()?.toLowerCase();
        let iconSrc = '/file-icons/default.png'
        let extensionTone = "bg-slate-100 text-slate-700";
        switch (extension) {
            case 'pdf':
                iconSrc = '/file-icons/pdf.png'
                extensionTone = "bg-red-100 text-red-700";
                break;
            case 'xls':
            case 'xlsx':
                iconSrc = '/file-icons/xls.png'
                extensionTone = "bg-green-100 text-green-700";
                break;
            case 'csv':
                iconSrc = '/file-icons/csv.png'
                extensionTone = "bg-emerald-100 text-emerald-700";
                break;
            default:
                iconSrc = '/file-icons/default.png'
                extensionTone = "bg-slate-100 text-slate-700";
                break;
        }

        return (
            <button
                type="button"
                onClick={() => downloadDocument(item)}
                className="flex items-center justify-between w-full text-left hover:bg-gray-50 rounded-lg p-2 transition-all border border-transparent hover:border-gray-200"
            >
                <div className="flex items-center gap-2 min-w-0">
                    <div className="size-10 rounded-lg bg-gray-100 flex items-center justify-center shrink-0">
                        <img src={iconSrc} alt="" className="size-7" />
                    </div>
                    <div className="flex flex-col items-start min-w-0">
                        <p className="text-sm font-medium truncate max-w-[180px]">{item?.name}</p>
                        <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${extensionTone}`}>
                            {(extension || "FILE").toUpperCase()}
                        </span>
                    </div>
                </div>
                <div className="size-8 rounded-full bg-indigo-50 text-indigo-600 flex items-center justify-center shrink-0">
                    <Download size={16} />
                </div>
            </button>
        )
    }

    const loadCountryMap = [
        { name: "Load Address", value: "loadAddress" },
        { name: "Load City", value: "loadCity" },
        { name: "Load Country", value: "loadCountry" },
    ]

    const unloadCountryMap = [
        { name: "Unload Address", value: "unloadAddress" },
        { name: "Unload City", value: "unloadCity" },
        { name: "Unload Country", value: "unloadCountry" },
    ]

    const dimensionsMap = [
        { name: "Length", value: "length" },
        { name: "Width", value: "width" },
        { name: "Height", value: "height" },
        { name: "Volume Weight", value: "volumeWeight" },
        { name: "Chargeable Weight", value: "chargeableWeight" },
        { name: "Quantity", value: "quantity" },
    ];

    const progressMap = [
        { name: "Collection", value: "Collection", icon: PackageOpen },
        { name: "Compliance", value: "Compliance", icon: ClipboardCheck },
        { name: "In Transit", value: "In Transit", icon: Plane },
        { name: "Custom Clearance", value: "Custom Clearance", icon: BadgeCheck },
        { name: "Final Delivery", value: "Final Delivery", icon: Truck },
        { name: "Delivered", value: "Delivered", icon: PackageCheck },
    ]

    const currentStatus = useMemo(() => {
        const subStatus = shipment?.orderDetails?.subStatus;
        const status = shipment?.status;

        if (
            status?.toLowerCase() === "completed" ||
            status?.toLowerCase() === "delivered" ||
            subStatus?.toLowerCase() === "delivered" ||
            subStatus?.toLowerCase() === "completed"
        ) {
            return progressMap.length - 1;
        }

        if (subStatus) {
            const idx = progressMap.findIndex(
                (item) => item.value.toLowerCase() === subStatus.toLowerCase()
            );
            if (idx !== -1) return idx;
        }

        if (status) {
            const idx = progressMap.findIndex(
                (item) => item.value.toLowerCase() === status.toLowerCase()
            );
            if (idx !== -1) return idx;
        }

        return -1;
    }, [shipment, progressMap]);

    const progressPercentage = useMemo(() => {
        if (currentStatus === -1) return 0;
        return animateNow ? (currentStatus / (progressMap.length - 1)) * 100 : 0;

    }, [currentStatus, progressMap.length, animateNow]);

    const getVolumeWeight = useCallback((item) => {
        const vw = calculateVolumeWeight(
            item?.length?.value,
            item?.width?.value,
            item?.height?.value,
            item?.length?.unit,
            item?.quantity
        );
        // Show exact (to two decimals) rather than flooring to an integer
        return Number.isFinite(vw) ? Number(vw.toFixed(2)) : 'N/A';
    }, [shipment]);

    const getChargeableWeight = useCallback((item) => {
        return Math.floor(Math.max(
            calculateVolumeWeight(item?.length?.value, item?.width?.value, item?.height?.value, item?.length?.unit, item?.quantity),
            item?.quantity * item?.weight?.value
        ))
    }, [shipment]);

    useEffect(() => {
        if (Object.keys(shipment).length > 0) {
            setAnimateNow(false);
            const timer = setTimeout(() => {
                setAnimateNow(true);
            }, 200)
            return () => clearTimeout(timer);
        } else {
            setAnimateNow(false);
        }
    }, [shipment])

    return (
        <div>
            <DashboardLayout>
                <Modal
                    title="Comment"
                    open={isModalOpen}
                    centered
                    footer={null}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    width={"70%"}
                    styles={{ body: { padding: 0 } }}
                >
                    <AskForModel id={selectedId} />
                </Modal>

                <div className="w-full h-full ">
                    <Header title="Tracking Shipments" />
                    <div className="w-full h-full flex flex-col items-center justify-start gap-4 p-6">
                        <div className="bg-white rounded-lg w-full flex items-end justify-center gap-2 p-4">
                            <div className="flex flex-col grow items-start justify-center">
                                <p className='text-sm font-medium'>Track Your Shipment</p>
                                <input
                                    type="text"
                                    placeholder="Enter Tracking Number"
                                    value={searchQuery}
                                    onChange={(e) => {
                                        const onlyNumbers = e.target.value.replace(/\D/g, '');
                                        setSearchQuery(onlyNumbers)
                                    }}
                                    className="border border-gray-300 rounded-md px-4 py-2 w-full"
                                />
                            </div>
                            <button disabled={loading} type="button" onClick={handleSearch} className='btnBg px-4 py-2 rounded mb-0.5 bg-opacity-50'>
                                {loading ? "Loading..." : "Track Shipment"}
                            </button>
                        </div>
                        {loading && Object.keys(shipment).length === 0 ? (
                            <div className="w-full h-full bg-white rounded-lg flex flex-col items-center justify-center">
                                <div className="flex items-center justify-center rounded-full p-5 aspect-square bg-blue/10 text-blue">
                                    <PackageOpen size={64} strokeWidth={1.25} />
                                </div>
                                <h3 className='text-3xl font-semibold'>Loading Tracking Details...</h3>
                                <p>Please wait while we fetch your shipment details</p>
                            </div>
                        ) : Object.keys(shipment).length === 0 ? (
                            <div className="w-full h-full bg-white rounded-lg flex flex-col items-center justify-center">
                                <div className="flex items-center justify-center rounded-full p-5 aspect-square bg-blue/10 text-blue">
                                    <PackageOpen size={64} strokeWidth={1.25} />
                                </div>
                                <h3 className='text-3xl font-semibold'>No Shipment Found</h3>
                                <p>Enter a valid Tracking Number to track your shipment</p>
                            </div>
                        ) : (
                            <div className=" rounded-lg w-full flex flex-col items-center justify-start gap-4">
                                <div className="w-full flex items-end justify-between gap-2 bg-cus-blue rounded-lg p-4 text-white">
                                    <div className="flex flex-col items-start justify-center">
                                        <p>Order Number</p>
                                        <p className='font-semibold text-3xl'>{shipment?.orderNumber}</p>
                                    </div>
                                    {shipment?.orderDetails?.subStatus && (
                                        <div className="flex items-center gap-2 bg-blue bg-opacity-30 text-lg rounded-lg shine px-4 py-2">
                                            <div className="size-3 rounded-full bg-green-500 shadow shadow-green-500/50" />
                                            <p>{shipment.orderDetails.subStatus}</p>
                                        </div>
                                    )}
                                </div>
                                <div className="flex items-stretch justify-center gap-4 w-full">

                                    {/* Collection Address */}
                                    <div className="bg-white h-full w-full flex items-start gap-4 p-4 rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300">

                                        <div className="flex items-center rounded-lg text-indigo-600 bg-indigo-500/10 p-2">
                                            <Package size={32} strokeWidth={1.5} />
                                        </div>

                                        <div className="flex flex-col w-full flex-1">
                                            <p className=" text-lg">Collection Address:</p>
                                            {loadCountryMap.map((item) => (
                                                <p className="text-xl font-medium leading-snug ">{shipment[item.value]}</p>
                                            ))}
                                        </div>

                                    </div>

                                    {/* Delivery Address */}
                                    <div className="bg-white h-full w-full flex items-start gap-4 p-4 rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300">
                                        <div className="flex items-center rounded-lg text-green-600 bg-green-500/10 p-2">
                                            <MapPin size={32} strokeWidth={1.5} />
                                        </div>
                                        <div className="flex flex-col w-full flex-1">
                                            <p className=" text-lg">Delivery Address:</p>
                                            {unloadCountryMap.map((item) => (
                                                <p className="text-xl font-medium leading-snug ">{shipment[item.value]}</p>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="flex flex-col items-start justify-between w-full gap-4 p-4 px-6 rounded-lg bg-white shadow-lg hover:shadow-2xl transition-all duration-300">
                                    <p className="text-xl font-medium">Shipment Progress</p>
                                    <div className="relative flex items-center justify-between w-full py-5">
                                        <div className="absolute top-1/3 bg-gray-200 rounded-full h-2 w-full z-0" />
                                        <div className="absolute top-1/3 bg-blue rounded-full  h-2 z-0 transition-all duration-1000 ease-out" style={{ width: `${progressPercentage}%` }} />
                                        {progressMap.map(({ name, icon: Icon }, idx) => {
                                            const isCompleted = animateNow && idx <= currentStatus
                                            return (
                                                <div key={idx} className=" flex flex-col items-center justify-center">
                                                    <div className={`flex items-center aspect-square rounded-full p-4 z-10 transition-all duration-1000 ease-in-out ${isCompleted ? "bg-blue text-white shine" : "bg-gray-200 text-gray-600"} `}>
                                                        {/* <Icon size={48} strokeWidth={1.5} /> */}
                                                        {idx < currentStatus ? <CheckCircle size={48} strokeWidth={1.5} /> : <Icon size={48} strokeWidth={1.5} />}
                                                    </div>
                                                    <p className="font-medium">{name}</p>
                                                    <p className={`text-xs rounded p-1 font-medium ${isCompleted ? 'bg-green-100 text-green-600' : 'bg-amber-100 text-amber-600'}`}>{isCompleted ? 'Completed' : 'Pending'}</p>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>

                                <div className="flex items-start justify-center gap-4 w-full min-h-[200px] mb-6">
                                    <div className="bg-white h-full w-full flex flex-col items-start justify-between gap-4 p-4 rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300">
                                        <div className="flex items-center gap-2">
                                            <div className="flex items-center rounded-lg text-indigo-600 bg-indigo-500/10 p-2">
                                                <Expand size={24} strokeWidth={1.75} />
                                            </div>
                                            <p className="text-lg font-medium">Product Dimensions</p>
                                        </div>
                                        <div className="flex flex-col w-full flex-1">
                                            {shipment?.pcsPackage?.map((item, idx) => (
                                                <div key={idx} className="grid grid-cols-2 gap-4 bg-gray-100 rounded-xl p-2">
                                                    {dimensionsMap.map((dim, dIdx) => {
                                                        const weightUnit = item['weight']?.unit || 'N/A';
                                                        let displayValue = item[dim.value]?.value || 'N/A';
                                                        let displayUnit = item[dim.value]?.unit || 'N/A';

                                                        if (dim.value === 'volumeWeight') {
                                                            displayValue = getVolumeWeight(item);
                                                            displayUnit = weightUnit;
                                                        } else if (dim.value === 'chargeableWeight') {
                                                            displayValue = getChargeableWeight(item);
                                                            displayUnit = weightUnit;
                                                        } else if (dim.value === 'quantity') {
                                                            displayValue = item?.quantity || 'N/A';
                                                            displayUnit = '';
                                                        }

                                                        const isLastItem = (dimensionsMap.length % 2 !== 0) && (dIdx === dimensionsMap.length - 1)

                                                        return (
                                                            <div key={dIdx} className={`flex flex-col items-start gap-2 bg-white rounded-lg p-2 shadow-md ${isLastItem ? 'col-span-2' : ''}`}>
                                                                <p className="text-sm font-medium">{dim.name}:</p>
                                                                <p className="text-lg font-medium">{displayValue} {displayUnit}</p>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="bg-white h-full w-full flex flex-col items-start justify-between gap-4 p-4 rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300">
                                        <div className="flex items-center gap-2">
                                            <div className="flex items-center rounded-lg text-indigo-600 bg-indigo-500/10 p-2">
                                                <FileText size={24} strokeWidth={1.75} />
                                            </div>
                                            <p className="text-lg font-medium">Documents</p>
                                        </div>

                                        <div className="w-full bg-gray-100 flex-1 flex items-start justify-center rounded-xl p-2 max-h-[320px] overflow-y-auto">
                                            {shipmentDocuments.length === 0 ? (
                                                <div className="flex flex-col !self-center items-center justify-center py-8">
                                                    <div className="flex items-center rounded-lg text-gray-600 bg-gray-500/10 p-2">
                                                        <FileText size={24} strokeWidth={1.75} />
                                                    </div>
                                                    <p className="font-medium text-lg">No Documents Available</p>
                                                    <p className="font-light text-sm">Documents will appear here when uploaded.</p>
                                                </div>
                                            ) : (
                                                <div className="grid grid-cols-2 gap-4 w-full">
                                                    {shipmentDocuments.map((item, idx) => (
                                                        <div key={idx} className="flex flex-col items-start gap-2 bg-white rounded-lg p-2 shadow-md">
                                                            {renderDoc(item)}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </DashboardLayout>
        </div>
    );
};

export default Tracking;